import axiosInstance from "../config/axios.config";

export const getPatientDetailsApi = (id) => {
  return axiosInstance.get(`/inpatient/patient-details/${id}/`);
};

export const submitReferralFormApi = (payload) => {
  return axiosInstance.post("inpatient/referral-form/", payload);
};
export const getReferralFormApi = (id) => {
  return axiosInstance.get(`inpatient/referral-form/${id}/`);
};
export const updateReferralFormApi = (id, payload) => {
  return axiosInstance.patch(`inpatient/referral-form/${id}/`, payload);
};
/**
 * Saves the TinyMCE-edited document. PATCH is the structured-data path and
 * silently drops pdf_html; PUT with { html } is the document path and is what
 * actually persists it (same contract as the discharge summary).
 */
export const updateReferralFormHtmlApi = (ipAdmissionId, html) => {
  return axiosInstance.put(`inpatient/referral-form/${ipAdmissionId}/`, {
    html,
  });
};

export const getListReferralFormApi = (admissionId) => {
  return axiosInstance.get(
    `inpatient/referral-form/?ip_admission=${admissionId}`
  );
};
export const getReferralFormByIdApi = (formId) => {
  return axiosInstance.get(`inpatient/referral-form/${formId}/`);
};
export const updateReferralFormByIdApi = (formId, payload) => {
  return axiosInstance.patch(`inpatient/referral-form/${formId}/`, payload);
};
export const updateReferralFormHtmlByIdApi = (formId, html) => {
  return axiosInstance.put(`inpatient/referral-form/${formId}/`, { html });
};


export const getListInvestigationFormApi = (admissionId) => {
  return axiosInstance.get(
    `inpatient/investigation-referral-form/?ip_admission=${admissionId}`
  );
};
export const getInvestigationFormByIdApi = (formId) => {
  return axiosInstance.get(`inpatient/investigation-referral-form/${formId}/`);
};
export const updateInvestigationFormByIdApi = (formId, payload) => {
  return axiosInstance.patch(
    `inpatient/investigation-referral-form/${formId}/`,
    payload
  );
};
export const updateInvestigationFormHtmlByIdApi = (formId, html) => {
  return axiosInstance.put(`inpatient/investigation-referral-form/${formId}/`, {
    html,
  });
};


export const submitDeathFormApi = (payload) => {
  return axiosInstance.post("inpatient/death-form/", payload);
};
export const getDeathFormApi = (id) => {
  return axiosInstance.get(`inpatient/death-form/${id}/`);
};
export const updateDeathFormApi = (id, payload) => {
  return axiosInstance.patch(`inpatient/death-form/${id}/`, payload);
};
/* Document-save counterpart of updateDeathFormApi. An admission holds a single
   death summary, so this is keyed by the admission id like its PATCH sibling -
   the same split as updateReferralFormHtmlApi: PATCH carries structured data,
   PUT carries the html. */
export const updateDeathFormHtmlApi = (ipAdmissionId, html) => {
  return axiosInstance.put(`inpatient/death-form/${ipAdmissionId}/`, { html });
};
export const submitInvestigationFormApi = (payload) => {
  return axiosInstance.post("inpatient/investigation-referral-form/", payload);
};
export const getInvestigationFormApi = (id) => {
  return axiosInstance.get(`inpatient/investigation-referral-form/${id}/`);
};
export const updateInvestigationFormApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/investigation-referral-form/${id}/`,
    payload
  );
};
export const submitReviewFormApi = (payload) => {
  return axiosInstance.post("inpatient/review-form/", payload);
};
export const getListReviewFormApi = (id) => {
  return axiosInstance.get(`inpatient/review-form/?ip_admission=${id}`);
};
export const getReviewFormApi = (id) => {
  return axiosInstance.get(`inpatient/review-form/${id}/`);
};
export const updateReviewFormApi = (id, payload) => {
  return axiosInstance.patch(`inpatient/review-form/${id}/`, payload);
};
/** Document-save counterpart of updateReferralFormHtmlApi. */
export const updateReviewFormHtmlApi = (id, html) => {
  return axiosInstance.put(`inpatient/review-form/${id}/`, { html });
};
/* Emergency Shift Form. Like Review, Referral and Investigation Referral, an
   admission can hold several of these, so the list is fetched per admission and
   a record is addressed by its own id. */
export const submitEmergencyShiftFormApi = (payload) => {
  return axiosInstance.post("inpatient/emergency-shift-form/", payload);
};
export const getListEmergencyShiftFormApi = (admissionId) => {
  return axiosInstance.get(
    `inpatient/emergency-shift-form/?ip_admission=${admissionId}`
  );
};
export const getEmergencyShiftFormByIdApi = (formId) => {
  return axiosInstance.get(`inpatient/emergency-shift-form/${formId}/`);
};
export const updateEmergencyShiftFormByIdApi = (formId, payload) => {
  return axiosInstance.patch(
    `inpatient/emergency-shift-form/${formId}/`,
    payload
  );
};
/** Document-save path: PATCH carries structured data, PUT carries the html. */
export const updateEmergencyShiftFormHtmlByIdApi = (formId, html) => {
  return axiosInstance.put(`inpatient/emergency-shift-form/${formId}/`, {
    html,
  });
};

export const printFormApi = (params) => {
  return axiosInstance.post(`inpatient/print-form/?${params}`);
};
/**
 * Shares a printable IP form with any number of email and WhatsApp recipients.
 *
 *   POST inpatient/share-form/?form_type=review&form_id=12
 *   { email: [{ name, email }], whatsapp: [{ name, whatsapp }] }
 *
 * form_type is one of review | referral | death | investigation |
 * emergency_shift, matching
 * print-form's convention. Both lists are optional but one must be non-empty.
 */
export const shareIpFormApi = (formType, formId, payload) => {
  return axiosInstance.post(
    `inpatient/share-form/?form_type=${formType}&form_id=${formId}`,
    payload
  );
};
export const getListNutritionistReassessmentFormApi = (id) => {
  return axiosInstance.get(
    `inpatient/nutrition-reassessment/?admission_id=${id}`
  );
};
export const getNutritionistReassessmentFormApi = (id) => {
  return axiosInstance.get(`inpatient/nutrition-reassessment/${id}/`);
};
export const submitNutritionistReassessmentFormApi = (payload) => {
  return axiosInstance.post("inpatient/nutrition-reassessment/", payload);
};
export const updateNutritionistReassessmentFormApi = (id, payload) => {
  return axiosInstance.patch(
    `inpatient/nutrition-reassessment/${id}/`,
    payload
  );
};
